<template>
	<div class="page-mdl">
		
		<!-- 广告幻灯片 -->
		<section class="banner-slide">
			<div class="swiper-container" id="bannerSlide" >
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="item in bannerList">
						<a :href="item.url" target="_blank"><img :src="item.value" alt=""></a>
					</div>
				</div>
				<div class="swiper-pagination" slot="pagination"></div>
			</div>
		</section>
		
		<!-- 新闻列表 -->
		<section class="news-mdl w1200" id="newsBox">
			<div class="news-box" v-for="(item,index) in categoryList" :key="item.catid">
				<div class="news-head">
					<h3 class="h3">{{item.catename}}</h3>
					<a class="more" href="javascript:;" @click="moreGo(item)">更多>></a>
				</div>
				<ul class="list">
					<li v-for="(item2,index2) in item.list" :key="item2.id" @click="goDetail(item2)">
						<!-- <span class="date">{{item2.inputtime}}</span> -->
						<i class="dot"></i><p>{{item2.title}}</p>
					</li>
				</ul>
			</div>
		</section>
		
		<div class="zqgb-mdl" v-if="zqgbInfo.list && zqgbInfo.list.length>0">
			<h2 class="zqgb-title"><img src="../../assets/img/zqgb-tit.png" alt=""></h2>
			<div class="zqgb-ctn w1200">
				<div class="swiper-container zqgb-swiper" id="zqgbSwiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in zqgbInfo.pageList" :key="index">
							<ul class="zqgb-list">
								<li v-for="(item2,index2) in item" :key="index2" @click="openZqgbPop(index*9+index2)">
									<h3>{{item2.title}}</h3>
									<p>{{item2.description}}</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<span class="zqgb-prev" @click="changeZqgbSwiper('prev')" v-if="zqgbNowIndex>0"></span>
				<span class="zqgb-next" @click="changeZqgbSwiper('next')" v-if="zqgbNowIndex<zqgbInfo.pageList.length-1"></span>
			</div>
		</div>
		
		<!-- 精彩图集 -->
		<section class="image-slide-mdl">
			<h2 class="image-slide-title">精彩图集</h2>
			<div class="image-slide-box" :style="'width:'+ (btmBannerWidth+160) +'px'">
				<div class="swiper-container image-slide" id="imagesSwiper"  :style="'width:'+ btmBannerWidth +'px'">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in btmBannerList" :key="index">
							<img class="img" :src="item.value" alt="">
						</div>
					</div>
				</div>
				<span class="prev" @click="changeImgSwiper('prev')"></span>
				<span class="next" @click="changeImgSwiper('next')"></span>
			</div>
		</section>
		
		<!-- 友情链接 -->
		<section class="index-friend-link w1200">
			<h2 class="title">相关链接</h2>
			<div class="link-list" v-if="friendLink">
				<!-- <a :href="item.url" target="_blank" v-for="(item,index) in friendLink" :key="index">{{item.name}}</a> -->
				<a :href="item.url" target="_blank" v-for="(item,index) in friendLink" :key="index">
					<img class="img" :src="item.thumb" alt="">
				</a>
			</div>
		</section>
		
		<!-- 通用底部 -->
		<footer class="index-footer">
			<span>版权所有：国家开放大学宣传部（新闻中心）</span>
			<span>技术支持：国开在线教育科技有限公司 </span>
		</footer>
		
		<!-- 真情告白弹窗 -->
		<div class="mask-bg" v-if="zqgbPopLoad" v-show="zqgbPopShow">
			<div class="pop-mdl pop-zqgb">
				<span class="close-btn" @click="closeZqgbPop">×</span>
				<div class="title">百年真情告白</div>
				<div class="pop-zqgb-swiper-box" v-if="zqgbInfo.list && zqgbInfo.list.length>0">
					<div class="swiper-container pop-zqgb-swiper" id="zqgbSwiper2">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in zqgbInfo.list" :key="index">
								<h3>{{item.title}}</h3>
								<div class="content" v-html="item.content"></div>
							</div>
						</div>
					</div>
					<span class="zqgb-prev" @click="changeZqgbSwiper2('prev')"></span>
					<span class="zqgb-next" @click="changeZqgbSwiper2('next')"></span>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import configMixin from '@/mixins/index.js'
import pageMixin from '@/mixins/page.js'
import Swiper from 'swiper';
export default {
	mixins: [configMixin,pageMixin],
	name: 'pageIndex',
	data () {
		return {
			navIndex:-1,
			categoryList:[],	//栏目列表（所有
			
			bannerList:[],	//广告幻灯片
			btmBannerList:[],	//底部幻灯片
			btmBannerWidth:1400,	
			slidesPerView:5,
			
			zqgbInfo:{},
			zqgbNowIndex:0,
			
			zqgbPopLoad:false,
			zqgbPopShow:false,
			
		}
	},
	
	created(){
		
	},
  
	computed:{

	},
	
	mounted(){
		var winW = this.winW<1920?this.winW:1920
		var slidesPerView = parseInt((winW-160)/320)
		this.btmBannerWidth = 320*slidesPerView
		this.slidesPerView = slidesPerView
		this.getNewCategoryList()
		this.getHundredYears()
		
		//中间轮播图
		this.getBanner('indexBanner').then((list)=>{
			this.bannerList = list
			setTimeout(()=>{
				this.bannerSwiper()
			},300)
			
		})
		
		// 底部轮播图
		this.getBanner('bottomBanner').then((list)=>{
			this.btmBannerList = list
			setTimeout(()=>{
				this.imagesSwiper()
			},300)
		})

	},
  
	methods:{
		
		//获取广告banner图
		getBanner(space_code,limit){
			return new Promise((resolve,reject)=>{
				this.$axios({
					url:'/index.php?s=poster&c=api&m=getPosterList',
					params:{
						space_code:space_code	,//广告位编码 topBanner=顶部大图，indexBanner=中间轮播图，bottomBanner=底部滚动图
						limit:(limit?limit:10),		//限制条数
					},
					success:(res)=>{
						resolve(res.data)
					}
				})
			})
		},
		
		//获取首页栏目
		getNewCategoryList(){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getIndexNewCategory',
				success:(res)=>{
					this.categoryList = res.data
				}
			})
		},
		
		//获取真情告白列表
		getHundredYears(){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getHundredYears',
				success:(res)=>{
					var zqgbInfo =  res.data
					zqgbInfo.pageList = []
					//console.log('zqgbInfo',zqgbInfo)
					zqgbInfo.list.forEach((item,index)=>{
						var pageIndex = parseInt(index/9)
						if(!zqgbInfo.pageList[pageIndex]){
							zqgbInfo.pageList[pageIndex] = []
						}
						item.content = item.content.replace(/\<img/gi, '<img style="max-width:100%; margin-bottom:10px;"');
						zqgbInfo.pageList[pageIndex].push(item)
					})
					
					this.zqgbInfo = zqgbInfo
					this.zqgbPopLoad = true
					setTimeout(()=>{
						this.zqgbSwiper()
					},300)
					
				}
			})
		},
		
		//更多跳转
		moreGo(item){
			if(!item.more){
				this.goUrl({ name:'pageList', params:{ catid:item.catid}})
			}else{
				this.goUrlOut(item.more)
			}
		},
		
		//跳转详情
		goDetail(item2){
			this.goUrl({ name:'pageDetail', params:{ id:item2.id}})
		},
		
		//真情告白轮播图
		zqgbSwiper(){
			var _this = this
			this.mySwiper3 = new Swiper ('#zqgbSwiper', {
				slidesPerView:1,
				//loop: true,
				 on: {
				    slideChangeTransitionEnd: function(){
						_this.zqgbNowIndex = this.activeIndex
				    },
				  },
			})
		},
		changeZqgbSwiper(type){
			if(type=='prev'){
				this.mySwiper3.slidePrev();
			}else if(type=='next'){
				this.mySwiper3.slideNext();
			}
		},
		
		//打开真情告白弹窗详情
		openZqgbPop(index){
			this.zqgbPopShow = true
			if(!this.mySwiper4){
				console.log('index1',index)
				setTimeout(()=>{
					this.zqgbSwiper2(index)
				},300)
			}else{
				console.log('index2',index)
				this.mySwiper4.slideTo(index+1)
			}
		},
		closeZqgbPop(){
			this.zqgbPopShow = false
		},
		//真情告白弹窗轮播图
		zqgbSwiper2(index){
			this.mySwiper4 = new Swiper ('#zqgbSwiper2', {
				initialSlide:index,
				slidesPerView:1,
				loop: true,
			})
		},
		changeZqgbSwiper2(type){
			//console.log('changeZqgbSwiper2',this.mySwiper4.activeIndex)
			if(type=='prev'){
				var num = this.mySwiper4.activeIndex>0?this.mySwiper4.activeIndex-1:this.zqgbInfo.list.length-1
				this.mySwiper4.slideTo(num);
			}else if(type=='next'){
				var num = this.mySwiper4.activeIndex<this.zqgbInfo.list.length+1?this.mySwiper4.activeIndex+1:0
				this.mySwiper4.slideTo(num);
			}
		},
		
		// banner幻灯片
		bannerSwiper(){
			this.mySwiper = new Swiper ('#bannerSlide', {
				loop: true,
				slidesPerView:1,
				pagination:{
				  el:'.swiper-pagination',
				  clickable:true,
				},
				autoplay: {
				    delay: 3000,
				    stopOnLastSlide: false,
				    disableOnInteraction: false,
				},
			})
		},
		imagesSwiper(){
			this.mySwiper2 = new Swiper ('#imagesSwiper', {
				loop: true,
				slidesPerView:this.slidesPerView,
				navigation: {
				  nextEl: '.next',
				  prevEl: '.prev',
				},
				autoplay: {
				    delay: 3000,
				    stopOnLastSlide: false,
				    disableOnInteraction: false,
				},
			})
		},
		changeImgSwiper(type){
			if(type=='prev'){
				this.mySwiper2.slidePrev();
			}else if(type=='next'){
				this.mySwiper2.slideNext();
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@/assets/css/swiper.less';

/* 广告幻灯片 */
.banner-slide{
	width:1200px; height:490px; margin:0 auto 0; overflow: hidden; padding-top:30px;
	a{width:100%; height:490px; display:block;
		img{width:100%; height:490px;}
	}
}

/* 新闻列表 */
.news-mdl{ 
	display:flex; justify-content: space-between; flex-wrap: wrap; margin-top:30px; padding:100px 30px 40px; box-sizing: border-box; background:#FFF9F1;
	.news-box{ 
		width:550px; margin-bottom:60px; 
		.news-head{ 
			height:40px; border-bottom:2px solid #cccccc; display:flex; justify-content: space-between; padding-right:10px; margin-bottom:15px;
			.h3{
				font-size:22px; color:#990100; display:inline-block; height:40px; 
				line-height:40px; border-bottom:2px solid #990100; padding:0 10px; font-weight:bold;
				background-image: -webkit-linear-gradient(top, #c02700, #740000); -webkit-background-clip: text; -webkit-text-fill-color: transparent; 
			}
			.more{ font-size:16px; color:#990100; height:40px; line-height:40px; }
		}
		.list{
			li{ 
				height:34px; line-height:34px; overflow:hidden;
				.date{font-size:14px; color:#999; line-height:34px; float:right; }
				.dot{ float:left; width:6px; height:6px; background:#666666; border-radius:100%; margin-top:14px; margin-right:8px; }
				p{font-size:16px; color:#666; line-height:34px;display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; cursor: pointer;
					&:hover{text-decoration: underline;}
				}
			}
		}
	}
}

/* 首页-精彩图集 */
.image-slide-mdl{ 
	background:url(~@/assets/img/slide-box-bg.png) #c20000 no-repeat center top; background-size:100% 100%; height:400px;  position:relative;
	.image-slide-title{font-size:24px; color:#000; text-align:center; font-weight: bold; padding:30px 0 60px; line-height:30px;}
	.image-slide-box{
		position:relative; margin:0 auto; width:100%;
		.image-slide{
			 width:(100% - 160px); margin:0 auto; position:relative;
			.img{width:300px; height:200px; margin:0 10px;}
		}
		.prev,.next{position:absolute;  top:50%; width:50px; height:50px; margin-top:-25px;  cursor: pointer; border:none; -webkit-tap-highlight-color:rgba(0,0,0,0); }
		.prev{left:30px; background:url(~@/assets/img/prev-btn.png) no-repeat;}
		.next{right:30px; background:url(~@/assets/img/next-btn.png) no-repeat;}
		.prev:focus,.next:focus { outline: none; }
	}
	
}

//真情告白
.zqgb-mdl{
	padding:70px 0;
	.zqgb-title{ text-align:center; margin-bottom:40px;}
	.zqgb-ctn{
		padding:0 110px; box-sizing: border-box; position:relative;
		.zqgb-swiper{
			position:relative;
			.zqgb-list{
				display:flex; justify-content: flex-start; flex-wrap: wrap; padding-bottom:40px;
				li{
					width:326px; height:230px; background:url(../../assets/img/zqgb-bg01.png) no-repeat center center; box-sizing: border-box; padding:20px 35px; cursor: pointer;
					h3{font-size:16px; color:#333; line-height:24px; padding-left:25px; font-weight: bold; margin-bottom:5px;}
					p{font-size:14px; color:#333; line-height:22px; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 7;}
					&:nth-child(2),&:nth-child(6),&:nth-child(7){ background-image:url(../../assets/img/zqgb-bg02.png);}
					&:nth-child(3),&:nth-child(4),&:nth-child(8){ background-image:url(../../assets/img/zqgb-bg03.png);}
					&:nth-child(2),&:nth-child(5),&:nth-child(8){position:relative; top:40px;}
				}
			}
		}
		.zqgb-prev,.zqgb-next{position:absolute;  top:50%; width:72px; height:72px; margin-top:-36px;  cursor: pointer; border:none; -webkit-tap-highlight-color:rgba(0,0,0,0); }
		.zqgb-prev{left:30px; background:url(~@/assets/img/zqgb-prev.png) no-repeat;}
		.zqgb-next{right:30px; background:url(~@/assets/img/zqgb-next.png) no-repeat;}
		.zqgb-prev:focus,.zqgb-next:focus { outline: none; }
		.zqgb-prev:hover,.zqgb-next:hover { opacity: .7; }
	}
}


.mask-bg{
	.pop-zqgb{
		width:700px; padding:0 10px 50px;  background:url(~@/assets/img/pop-bg.png) #fff no-repeat right bottom;
		.title{ text-align:center; font-size:36px; color:#990100;  line-height:50px; padding:20px 0; border-bottom:2px solid #cccccc; margin-bottom:30px; }
		.pop-zqgb-swiper-box{
			padding:0 60px; box-sizing: border-box; position:relative;
			.pop-zqgb-swiper{
				position:relative;
				.swiper-slide{
					h3{font-size:24px; color:#333; line-height:36px; margin-bottom:15px;}
					p{font-size:18px; color:#666; line-height:32px; text-indent:2em;}
					.content{font-size:18px; color:#666; line-height:32px; max-height:530px; overflow:auto;}
				}
			}
			.zqgb-prev,.zqgb-next{position:absolute;  top:50%; width:40px; height:40px; margin-top:10px;  cursor: pointer; border:none; -webkit-tap-highlight-color:rgba(0,0,0,0);}
			.zqgb-prev{left:0; background:url(~@/assets/img/zqgb-prev.png) no-repeat; background-size:100% 100%;}
			.zqgb-next{right:0; background:url(~@/assets/img/zqgb-next.png) no-repeat; background-size:100% 100%; }
			.zqgb-prev:focus,.zqgb-next:focus { outline: none; }
			.zqgb-prev:hover,.zqgb-next:hover { opacity: .7; }
		}
	}
}


.index-friend-link{
	 background:#FFF9F1; padding:70px 0 30px;
	.title{
		font-size:22px; font-weight:bold; text-align:center; margin-bottom:50px;
		background-image: -webkit-linear-gradient(top, #c02700, #740000); -webkit-background-clip: text; -webkit-text-fill-color: transparent;
	}
	.link-list{
		text-align:center;
		a{ 
			display:inline-block; font-size:15px; margin:0 13px; color:#000; margin-bottom:15px;
			.img{height:72px;}
			&:hover{text-decoration: underline;}
		}
	}
}

.index-footer{
	padding:70px 0; text-align:center; border-top:1px solid #999999; margin:0 30px;
	span{display: inline-block; margin:0 30px; font-size:14px;}
}

.swiper-pagination{
	position:absolute; bottom:20px; left:0; z-index:9; width:100%; text-align:center;
	span{display:inline-block; width:15px; height:15px; background:rgba(255,255,255,.7); margin:0 6px; cursor: default;}
	.swiper-pagination-bullet-active{background:#cc0000;}
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue